import { TouchableOpacity } from "react-native-ui-lib";
import { cameraButtonStyles } from "../../constants";
import { Text } from "@towersystems/roam-common-native";

export interface TextButtonProps {
  onPress?: () => void;
  disabled?: boolean;
  label: string;
}

export function TextButton({ onPress, label, disabled }: TextButtonProps) {
  return (
    <TouchableOpacity
      {...{ disabled, onPress }}
      style={{
        ...cameraButtonStyles,
        width: "auto",
        backgroundColor: disabled ? "#CCC" : "hsla(210, 76%, 58%, 0.4)",
      }}
    >
      <Text style={{ color: "white", fontFamily: "Gilmer-Bold", fontSize: 17 }}>
        {label}
      </Text>
    </TouchableOpacity>
  );
}
